module.exports = __webpack_public_path__ + "img/search-files.52d1ec40.svg";